import script from "./grid-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./grid-menu.vue?vue&type=script&setup=true&lang=ts"

import "./grid-menu.vue?vue&type=style&index=0&id=d9bf11d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9bf11d8"]])

export default __exports__